/* eslint-disable @typescript-eslint/no-empty-object-type */ /* eslint-disable @typescript-eslint/no-unused-vars */ /* eslint-disable @typescript-eslint/no-namespace */ /* eslint-disable @typescript-eslint/no-explicit-any */ import { useMutation as __useMutation, useQuery as __useQuery } from "@tanstack/react-query";
import { HttpApi } from "@effect/platform";
import { Effect, pipe } from "effect";
import React from "react";
// export const make = <ApiId extends string, Groups extends HttpApiGroup.Any, ApiError, ApiR>(
//   api: HttpApi.HttpApi<ApiId, Groups, ApiError, ApiR>,
//   options?: {
//     readonly transformClient?:
//       | ((client: HttpClient.HttpClient) => HttpClient.HttpClient)
//       | undefined
//     readonly transformResponse?:
//       | ((effect: Effect.Effect<unknown, unknown, Scope>) => Effect.Effect<unknown, unknown, Scope>)
//       | undefined
//     readonly baseUrl?: string | undefined
//   }
// ): Effect.Effect<
//   Simplify<ReactQueryClient<Groups, ApiError>>,
//   never,
//   | HttpApiMiddleware.HttpApiMiddleware.Without<ApiR | HttpApiGroup.ClientContext<Groups>>
//   | HttpClient.HttpClient
// > =>
//   // @ts-expect-error ...
//   Effect.gen(function* () {
//     const _client = yield* HttpApiClient.make(api)
//     console.log(api)
//     const client: Record<string, Record<string, any>> = { _client } as any
//     HttpApi.reflect(api as any, {
//       onGroup({ group }) {
//         if (group.topLevel) return
//         client[group.identifier] = {}
//       },
//       onEndpoint({ endpoint, group }) {
//         const isGet = endpoint.method === "GET"
//         ;(group.topLevel ? client : client[group.identifier])[endpoint.name] = isGet
//           ? {
//               useQuery: (input: unknown, opts?: any) => {
//                 const queryKey = [group.topLevel ? "$" : group.identifier, endpoint.name, input]
//                 return __useQuery({
//                   queryKey,
//                   queryFn: () =>
//                     Effect.runPromise(
//                       // @ts-expect-error ...
//                       (group.topLevel ? _client : _client[group.identifier as any])[endpoint.name](
//                         input
//                       )
//                     ),
//                   ...opts,
//                   suspense: false,
//                 })
//               },
//             }
//           : {
//               useMutation: (opts?: any) => {
//                 const mutationKey = [group.topLevel ? "$" : group.identifier, endpoint.name]
//                 const mutationFn = (input: unknown) => {
//                   console.log("mutationFn", input)
//                   return Effect.runPromise(
//                     (group.topLevel ? _client : _client[group.identifier as any])[endpoint.name](
//                       input
//                     )
//                   )
//                 }
//                 return __useMutation({ ...opts, mutationKey, mutationFn })
//               },
//             }
//       },
//     })
//     return client as any
//   })
export const makeObject = (api, runtimeContext, clientTag)=>{
    const clientObject = {};
    HttpApi.reflect(api, {
        onGroup ({ group }) {
            if (group.topLevel) return;
            clientObject[group.identifier] = {};
        },
        onEndpoint ({ endpoint, group }) {
            const isGet = endpoint.method === "GET";
            (group.topLevel ? clientObject : clientObject[group.identifier])[endpoint.name] = isGet ? {
                useQuery: (input, opts)=>{
                    const runtime = React.useContext(runtimeContext);
                    if (!runtime) throw new Error("No runtime available");
                    const queryKey = [
                        group.topLevel ? "$" : group.identifier,
                        endpoint.name,
                        input
                    ];
                    return __useQuery({
                        queryKey,
                        queryFn: ()=>runtime.runPromise(pipe(clientTag, Effect.flatMap((client)=>(group.topLevel ? client : client[group.identifier])[endpoint.name](input)))),
                        ...opts,
                        suspense: false
                    });
                }
            } : {
                useMutation: (opts)=>{
                    const runtime = React.useContext(runtimeContext);
                    if (!runtime) throw new Error("No runtime available");
                    const mutationKey = [
                        group.topLevel ? "$" : group.identifier,
                        endpoint.name
                    ];
                    const mutationFn = (input)=>{
                        console.log("mutationFn", input);
                        return runtime.runPromise(pipe(clientTag, Effect.flatMap((client)=>(group.topLevel ? client : client[group.identifier])[endpoint.name](input))));
                    };
                    return __useMutation({
                        ...opts,
                        mutationKey,
                        mutationFn
                    });
                }
            };
        }
    });
    return clientObject;
};
